/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Usev2courses2Inputs */

const de__field_usev2courses2 = /** @type {(inputs: _Field_Usev2courses2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Zuteilung nach Tagen aktivieren`)
};

/**

* @param {_Field_Usev2courses2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_usev2courses2 = /** @type {((inputs?: _Field_Usev2courses2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Usev2courses2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_usev2courses2(inputs)
});
export { _field_usev2courses2 as "_field_useV2Courses" }